// extracted by mini-css-extract-plugin
export default {"contentText":"contentText___1_QT_","map":"map___2ISFw"};